import * as action from "./actions";

export const hydrateApp = () => {
  return {
    type: action.HYDRATE_APP,
    payload: {}
  };
};

export const vendorHydrateApp = id => {
  return {
    type: action.VENDORHYDRATE_APP,
    payload: id
  };
};

const ACTION_HANDLERS = {
  [action.HYDRATE_APP]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.HYDRATE_SUCCESS]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.VENDORHYDRATE_APP]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = { hydrated: false };

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
